import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "api";
import {
  SegmentItemReactRequest,
  StoriesReactionRequest,
  StoriesRequest,
} from "api/models/community";

export const getHiveDetails = createAsyncThunk(
  "hive/getHiveDetails",
  async (body: any, { rejectWithValue }) => {
    try {
      const { data } = await api.community.getHiveDetails(body);
      return data;
    } catch (error) {
      return rejectWithValue("Something went wrong");
    }
  }
);

export const getStories = createAsyncThunk(
  "hive/getStories",
  async (body: StoriesRequest, { rejectWithValue }) => {
    try {
      const { data } = await api.community.getStories(body);
      return data.data;
    } catch (error) {
      return rejectWithValue("Something went wrong");
    }
  }
);

export const getStoryItem = createAsyncThunk(
  "hive/getStoryItem",
  async (body: StoriesRequest, { rejectWithValue }) => {
    try {
      const { data } = await api.community.getStoryItem(body);
      return data.data;
    } catch (error) {
      return rejectWithValue("Something went wrong");
    }
  }
);

export const updateStoryReaction = createAsyncThunk(
  "hive/updateStoryReaction",
  async (body: StoriesReactionRequest, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await api.community.updateStoryReaction(body);

      dispatch(
        getStorySegmentItemReact({
          storySegmentId: body.storySegmentId,
          sessionId: body.sessionId,
          storyUuid: body.storyUuid,
        })
      );
      return data.data;
    } catch (error) {
      return rejectWithValue("Something went wrong");
    }
  }
);

export const getStorySegmentItemReact = createAsyncThunk(
  "story/getStorySegmentItemReact",
  async (body: SegmentItemReactRequest, { rejectWithValue }) => {
    try {
      const { data } = await api.community.getSegmentItemReact(body);
      return data.data;
    } catch (error) {
      return rejectWithValue("Something went wrong");
    }
  }
);
